// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "8d4978e71f72dc79aa40e85bda2906f1d8b01325/static/css/" + chunkId + "." + "8ea9c403" + ".chunk.css";
};